import { createSelector } from 'reselect'
import { RedDataState } from '../../types'
const getDialogAppState = (state: RedDataState) => state.dialogApp

const getIsVisible = createSelector(getDialogAppState, (dialogApp) => dialogApp.isVisible)

export { getIsVisible }
